import React from "react";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Grid from "@material-ui/core/Grid";
import gameHeaderStyles from "../../common/styles/sports/GameHeader.styles";
import GameSummary from "./GameSummary";

const GameHeader = ({ title, description }) => {
	const classes = gameHeaderStyles();
	const notMd = useMediaQuery((theme) => theme.breakpoints.up("md"));

	return (
		<Grid
			container
			justifyContent="space-between"
			alignItems="center"
			className={classes.root}
		>
			<Grid item sm={12} md={6}>
				<Typography variant="h3" className={classes.title}>
					{title}
				</Typography>
				<Typography variant="body1" className={classes.description}>
					{description}
				</Typography>
			</Grid>
			{notMd && (
				<Grid item sm={12} md={6}>
					<GameSummary size="small" preview />
				</Grid>
			)}
		</Grid>
	);
};

export default GameHeader;
